<c-card *transloco="let t">
  <c-card-body class="px-2">

          <c-row>
            <c-col md="12" lg="6">
                <h1>{{ t('Alerts') }}</h1>
            </c-col>
            <c-col md="12" lg="6">
            <c-row class="justify-content-end">
              <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                <c-input-group  class="text-end">
                  <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                  <select aria-label="Default select example" name="page" cSelect (change)="getAlerts()"  [(ngModel)]="pagination.page">
                    <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                  </select>
                </c-input-group>
              </c-col>
              <c-col xs="auto" class="mb-2">
                <c-input-group>
                  <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                  <select aria-label="Default select example" (change)="getAlerts()" name="sort" cSelect [(ngModel)]="sort">
                    <option value="newest">{{ t('Newest') }}</option>
                    <option value="oldest">{{ t('Oldest') }}</option>
                    <option value="name">{{ t('Name') }}</option>
                  </select>
                </c-input-group>
              </c-col>
            </c-row>
          </c-col>


          </c-row>
          <c-row>
            <c-col md="12" lg="6">
              <div class="card mb-2">
                <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseFilter" aria-expanded="true" aria-controls="collapseFilter">
                  <i class="fa-solid fa-chevron-down"></i> {{ t('Filter & Export Alerts') }}
                </div>
                <div class="card-body collapse" id="collapseFilter">
                  <form cForm class="align-items-center" (ngSubmit)="getAlerts()">
                    <div class="row mb-2">
                      <div class="col">
                        <div class="row mb-1">
                          <c-input-group>
                            <span cInputGroupText>
                              <svg cIcon class="me-2" name="cil-search"></svg>
                            </span>
                            <input cFormControl id="search" name="search" [(ngModel)]="search" placeholder="{{ t('Search') }}" />
                          </c-input-group>
                        </div>
                        <div class="row mb-1">
                          <div class="col">
                            <ng-select
                              [items]="okService.workers"
                              placeholder="{{ t('Worker') }}"
                              bindLabel="name"
                              bindValue="id"
                              name="worker_id"
                              [(ngModel)]="worker_id"
                            >
                            </ng-select>
                          </div>
                        </div>
                        <div class="row mb-1">
                          <div class="col">
                            <c-input-group>
                              <span cInputGroupText>{{ t('Verification') }}</span>
                              <select aria-label="Verification status" name="verify" cSelect [(ngModel)]="verify">
                                <option value="">{{ t('All') }}</option>
                                <option value="None">{{ t('None') }}</option>
                                <option value="Real Emergency">{{ t('Real Emergency') }}</option>
                                <option value="Test Alert">{{ t('Test Alert') }}</option>
                                <option value="False Alarm">{{ t('False Alarm') }}</option>
                              </select>
                            </c-input-group>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="row mb-1">
                          <c-input-group>
                            <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                            <input type="text" ngxDaterangepickerMd [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                          </c-input-group>
                        </div>
                        <div class="row mb-1">
                          <div class="col" *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                            <ng-select
                            [items]="okService.groups"
                            name="group"
                            placeholder="{{ t('Group') }}"
                            [(ngModel)]="group"
                            bindLabel="name"
                            bindValue="id">
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col align-items-center">
                        <button cButton class="btn btn-success text-white" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Filter Alerts') }}</button>
                        &nbsp;
                        <button class="btn btn-info text-white" cButton (click)="exportAlerts()">
                          <i class="fa-solid fa-file-excel"></i>
                          {{ t('Export Alerts') }}
                        </button>
                        &nbsp;
                        <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                          <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                           {{ t('Clear Filter') }}
                        </span>
                      </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- <c-card class="mb-2">
                <c-card-body>

                  <form cForm class="row row-cols-lg-auto g-3 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()" id="collapseFilter">

                    <c-row class="mb-2">
                      <c-col xs="auto">
                        <label cLabel class="visually-hidden" for="search">
                          {{ t('Search') }}
                        </label>
                        <c-input-group>
                          <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                          <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                        </c-input-group>
                      </c-col>
                    </c-row>

                    <c-row class="mb-2">
                      <c-col>
                        <c-input-group>
                          <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                          <input type="text" ngxDaterangepickerMd [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                        </c-input-group>
                      </c-col>
                    </c-row>
                    <c-row class="mb-2">
                      <c-col class="col-6">
                        <c-input-group>
                          <ng-select
                            [items]="okService.workers"
                            placeholder="{{ t('Worker') }}"
                            bindLabel="name"
                            bindValue="id"
                            formControlName="worker_id"
                          >
                          </ng-select>
                        </c-input-group>
                      </c-col>
                      <c-col class="col-6" *ngIf="groups.length> 0 && okService.hasFeature('groups')">
                        <c-input-group>
                          <ng-select
                          [items]="groups"
                          name="group"
                          placeholder="{{ t('Group') }}"
                          [(ngModel)]="group"
                          bindLabel="name"
                          bindValue="id">
                          </ng-select>
                        </c-input-group>
                      </c-col>
                    </c-row>


                    <c-row>
                      <c-col xs="auto">
                        <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Filter Alerts') }}</button>
                        &nbsp;
                        <button cButton class="btn btn-light text-danger" type="submit"  (click)="clearFilter()" *ngIf="hasFilter()">
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </c-col>
                      <c-col>
                        <button color="success" cButton (click)="exportAlerts()">
                          {{ t('Export Alerts') }}
                        </button>
                      </c-col>
                    </c-row>


                    </form>

                </c-card-body>
              </c-card> -->

        </c-col>
        <c-col md="12" lg="6" class="text-end">

          <button cButton class="btn btn-light my-2" (click)="toggleNotes()">
            <i class="fa-regular fa-clipboard"></i> {{ t('Toggle notes') }}
          </button>
        </c-col>
      </c-row>

          <c-row *ngIf="alerts">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Alert') }}</th>
                    <th scope="col">{{ t('Actions') }}</th>
                    <th scope="col">{{ t('Verification') }}</th>
                    <th scope="col" *ngIf="show_notes">{{t('Notes')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let alert of alerts">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/reports/alert/{{alert.id}}">
                          <i class="fa-solid fa-eye"></i> {{ t('View') }}
                        </button>
                      </td>
                      <td>
                        <i class="fa-solid fa-circle-check fa-3x text-success" *ngIf="alert.resolved"></i>
                        <i class="fa-solid fa-triangle-exclamation fa-3x text-warning" *ngIf="!alert.resolved"></i>
                      </td>
                      <td>
                        <span class="fs-5">{{alert.title}}</span>
                      </td>
                      <td>
                        <span *ngFor="let action of alert.actions" [innerHTML]="action.html"></span>
                      </td>
                      <td>
                        <ng-container *ngIf="alert.verify && alert.verify.type">
                          <span class="badge bg-light text-dark">{{alert.verify.type}}</span>
                        </ng-container>
                      </td>
                      <td *ngIf="show_notes">

                        <ng-container *ngIf="alert.notes">

                          <ng-container *ngIf="!isString(alert.notes)">

                            <ng-container *ngFor="let note of alert.notes">
                              <li class="list-group-item fs-6">{{note.notes}} <br/>
                                <ng-container *ngIf="note.name">
                                  ~ {{note.name}} at {{note.created_at}}
                                </ng-container>
                              </li>
                            </ng-container>

                          </ng-container>

                          <ng-container *ngIf="isString(alert.notes)">
                            <li class="list-group-item fs-6">{{alert.notes}}</li>
                          </ng-container>

                        </ng-container>

                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>
